<template>
  <div id="app-auto-top-up" class="app-auto-top-up top-up-width">
    <div class="topUp-cards-container">
      <!-- Automatic Top-Up Card -->
      <div class="topUp-cards-wrapper card1">
        <div class="topUp-card">
          <div class="topUp-card-header">
            <img src="/files/lidl/images/new-icons/svg/euro.svg" alt="" />
            <span class="text-xl text-semibold">Guthaben Aufladung</span>
          </div>
          <div class="topUp-card-body">
            <div class="body-element">
              <div class="info">
                <p class="text-sm">
                  Dein <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Guthaben wird automatisch aufgeladen,
                  wenn es unter einen bestimmten Betrag fällt.
                </p>
              </div>
              <div class="input-field">
                <label class="text-sm" for="trigger-amount">Guthabengrenze</label>
                <select
                  class="input"
                  name="trigger-amount"
                  id="trigger-amount"
                  v-model="inputTrigger"
                  @change.prevent="$emit('threshold')"
                  required
                >
                  <option v-for="option in triggerOptions" :value="option.value" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="input-field">
                <label class="text-sm" for="threshold-amount">Aufladebetrag</label>
                <select
                  class="input"
                  name="threshold-amount"
                  id="threshold-amount"
                  v-model="inputThreshold"
                  @change.prevent="$emit('threshold')"
                  required
                >
                  <option v-for="option in thresholdOptions" :value="option.value" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <button id="threshold" class="button button--secondary" @click.prevent="$emit('threshold')">
          Auswählen
          <img src="/files/lidl/images/new-icons/svg/check.svg" alt="" />
        </button>
      </div>
      <!-- Monthly Top-Up Card -->
      <div class="topUp-cards-wrapper card2">
        <div class="topUp-card">
          <div class="topUp-card-header">
            <img src="/files/lidl/images/new-icons/svg/calendar.svg" alt="" />
            <span class="text-xl text-semibold">Monatliche Aufladung</span>
          </div>
          <div class="topUp-card-body">
            <div class="body-element" v-for="day in monthlyValue" :key="day" :id="'monthly_' + day">
              <div class="info">
                <p class="text-sm">
                  Dein <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Guthaben wird automatisch einmal pro
                  Monat am {{ day }}. des Monats aufgeladen.
                </p>
              </div>
              <div class="input-field">
                <label class="text-sm" :for="'monthly-amount-' + day">Aufladebetrag</label>
                <select
                  class="input"
                  :name="'monthly-amount-' + day"
                  :id="'monthly-amount-' + day"
                  v-model="inputMonthly"
                  @change.prevent="$emit('monthly')"
                  required
                >
                  <option v-for="option in monthlyOptions" :value="option.value" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <button id="monthly" class="button button--secondary" @click.prevent="$emit('monthly')">
          Auswählen
          <img src="/files/lidl/images/new-icons/svg/check.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import price from '@/mixins/price'

export default {
  name: 'EnterAutoTopUp',
  data() {
    return {
      inputThreshold: 500,
      inputMonthly: 500,
      topUpAmounts_: {
        autoAmounts: {
          threshold: {
            amount: [],
            trigger: []
          },
          monthly: {
            amount: [500]
          }
        }
      }
    }
  },
  methods: {
    buildOptions(optionList) {
      const me = this
      return optionList.map(function(option) {
        return {
          value: option,
          text: me.price(option)
        }
      })
    }
  },
  watch: {
    selectedAutoTopUp: {
      immediate: true,
      handler: function(value) {
        this.$emit('update:trigger', value.trigger)
        this.$emit('update:amount', value.amount)
      }
    }
  },
  computed: {
    topUpAmounts: {
      get() {
        if (this.insideActivation) {
          return this.topUpAmountsStore
        } else {
          return this.topUpAmounts_
        }
      },
      set(value) {
        this.topUpAmounts_ = value
      }
    },
    ...mapGetters('activation/info', {
      topUpAmountsStore: 'topUpAmounts'
    }),
    ...mapGetters(['brand']),
    selectedAutoTopUp() {
      if (this.topUp) {
        if (this.topUp.type === 'monthly') {
          return Object.assign({}, this.topUp, { amount: this.inputMonthly })
        }
        if (this.topUp.type === 'byLimit') {
          return Object.assign({}, this.topUp, { amount: this.inputThreshold }, { trigger: this.inputTrigger })
        }
        return this.topUp
      }
      return {}
    },
    defaultTrigger: function() {
      if (this.topUp.type === 'byLimit' && this.topUp.trigger !== null) {
        const comp = this
        const otherTrigger = this.monthlyValue.find(function(option) {
          return option === comp.topUp.trigger
        })
        if (typeof otherTrigger === 'undefined') {
          return this.topUp.trigger
        }
      }
      return this.topUpAmounts.autoAmounts.threshold.defaultTrigger
    },
    triggerOptions: function() {
      return this.buildOptions(this.topUpAmounts.autoAmounts.threshold.trigger)
    },
    thresholdOptions: function() {
      return this.buildOptions(this.topUpAmounts.autoAmounts.threshold.amount)
    },
    monthlyOptions: function() {
      return this.buildOptions(this.topUpAmounts.autoAmounts.monthly.amount)
    }
  },
  mixins: [preFilledInput('inputTrigger', 'defaultTrigger'), price],
  props: {
    topUp: {
      type: Object
    },
    monthlyValue: {
      type: Array
    },
    insideActivation: {
      type: Boolean,
      default: false
    }
  },
  apollo: {
    topUpAmounts: function() {
      return wrapQuery(
        gql`
          query($brand: String!) {
            topUpAmounts(brand: $brand) {
              autoAmounts {
                monthly {
                  amount
                  default
                }
                threshold {
                  amount
                  default
                  defaultTrigger
                  trigger
                }
              }
            }
          }
        `,
        this,
        'topUpAmounts',
        {
          brand: this.brand
        },
        null,
        {
          fetchPolicy: 'cache-first',
          skip: this.insideActivation
        }
      )
    }
  }
}
</script>
